module.exports = __webpack_public_path__ + "static/pbtech_logo-a20581a9461447a08cd3430c7ca5c052.png";